import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useClient } from '../../client-api';
import { type SettingsUpdateDto, updateCashEventPanelSettings, type UpdateSettingsResponseDto } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export const useUpdateProjectionCashEventSettings = (): UseMutationResult<UpdateSettingsResponseDto, AxiosError, SettingsUpdateDto> => {
    const queryClient = useQueryClient();
    const { data: client } = useClient();

    return useMutation({
        mutationFn: (payload) => updateCashEventPanelSettings({ body: payload, path: { id: payload.id! } }).then((result) => result.data!),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.saeCashEventSettings(client?.partnerUuid) });
            queryClient.invalidateQueries({ queryKey: queryKeys.projection(client?.partnerUuid) });
            queryClient.invalidateQueries({ queryKey: queryKeys.cashFlow(client?.partnerUuid) });
        },
    });
};
